import Parse from 'parse'
import ParseViewModel from '@/utils/parse-object-pojo'

export const Applicant = Parse.Object.extend('Applicant', {
    /*
    // Instance methods
    hasSuperHumanStrength: function () {
        return this.get("strength") > 18;
    },
    // Instance properties go in an initialize method
    initialize: function (attrs, options) {
        this.sound = 'Rawr';
    },
    */
}, {
    /*
    // Class methods
    spawn: function(strength) {
        var monster = new Monster();
        monster.set('strength', strength);
        return monster;
    },
    */
});

export const ApplicantVM = ParseViewModel(Applicant, [
    'name',
    'files',
    'images',
]);

export default {
    Applicant,
    ApplicantVM
}



// WEBPACK FOOTER //
// ./src/models/applicant.js